import qs from 'qs';
import {filterParams, parseSearchParams} from '@ui/Form/utils';

export type SharedRestsQuery = Record<string, unknown>;

export const SHARED_RESTS_QUERY_KEYS = [
    'warehouses__addr_units__eq',
    'rests__external_warehouse_id__eq',
] as const;

const pickWhitelistedQuery = (query: SharedRestsQuery): SharedRestsQuery => {
    const subset: SharedRestsQuery = {};

    for (const key of SHARED_RESTS_QUERY_KEYS) {
        if (key in query) {
            subset[key] = query[key];
        }
    }

    return filterParams(subset);
};

export const pickSharedRestsQuery = (query?: SharedRestsQuery | null): SharedRestsQuery | undefined => {
    if (!query || typeof query !== 'object') {
        return undefined;
    }

    const filtered = pickWhitelistedQuery(query);
    return Object.keys(filtered).length > 0 ? filtered : undefined;
};

export const buildSharedRestsUrl = (productId: number, query?: SharedRestsQuery | null): string => {
    const base = `${window.location.origin}/shared/product/${productId}/rests`;
    const filters = pickSharedRestsQuery(query);

    if (!filters) {
        return base;
    }

    const search = qs.stringify({query: filters});
    return `${base}?${search}`;
};

export const SHARED_RESTS_SHARE_TITLE = 'Остатки товара';

export const buildSharedRestsShareBody = (productId: number, query?: SharedRestsQuery | null): string => {
    const url = buildSharedRestsUrl(productId, query);
    return `${SHARED_RESTS_SHARE_TITLE}\n${url}`;
};

export const buildTelegramShareUrl = (productId: number, query?: SharedRestsQuery | null): string => {
    const url = buildSharedRestsUrl(productId, query);
    const params = new URLSearchParams({url});
    return `https://t.me/share/url?${params.toString()}`;
};

export const buildMaxShareUrl = (productId: number, query?: SharedRestsQuery | null): string => {
    const params = new URLSearchParams({
        text: buildSharedRestsShareBody(productId, query),
    });
    return `https://max.ru/:share?${params.toString()}`;
};

export const buildEmailShareUrl = (productId: number, query?: SharedRestsQuery | null): string => {
    const params = new URLSearchParams({
        subject: SHARED_RESTS_SHARE_TITLE,
        body: buildSharedRestsShareBody(productId, query),
    });
    return `mailto:?${params.toString()}`;
};

export const parseSharedRestsParams = (searchParams: URLSearchParams): {query?: SharedRestsQuery} => {
    const parsed = parseSearchParams(searchParams);
    const query = parsed.query;

    if (!query || typeof query !== 'object' || Array.isArray(query)) {
        return {};
    }

    const filtered = pickWhitelistedQuery(query as SharedRestsQuery);
    return Object.keys(filtered).length > 0 ? {query: filtered} : {};
};

export const isSharedRestsPath = (pathname: string): boolean => {
    return /^\/shared\/product\/\d+\/rests\/?$/.test(pathname);
};
